// extracted by mini-css-extract-plugin
export default {"testSessionDetails":"testSessionDetails-kkffg","scoreContainer":"scoreContainer-fd1fw","noteContainer":"noteContainer-L6z3v"};